export enum ChapterState {
  pending = "pending",
  current = "current",
  done = "done",
}
